import { createStyles } from '@material-ui/styles';

export default () =>
  createStyles({
    root: {
      width: '100%',
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  });
